import AboutTimelineComponent from "./AboutTimelineComponent";

export default AboutTimelineComponent;